"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineTotal = void 0;
const roundTo_1 = require("../roundTo");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineTotalByType_1 = require("./getOrderLineTotalByType");
const getOrderLineTotal = (item, date) => {
    let total = 0;
    if (!item.versions)
        return total;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return total;
    if (latest_version.status.includes("CANCELLED"))
        return total;
    total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(latest_version.config, item.type, date);
    return (0, roundTo_1.roundTo)(total, 2);
};
exports.getOrderLineTotal = getOrderLineTotal;
